module.exports = __webpack_public_path__ + "assets/81df978cc7c21faf26184f724a9823f1.png";